import { memo } from 'react';
import type { FC } from 'react';

import { Link } from 'react-router-dom';
import classNames from 'classnames';

import { trackNavigationClick } from '../../shared/helpers/trackingHelpers';
import type { MenuItem } from '../Header/helpers';
import { isLocalUrl } from '../../shared/helpers/routes';
import { addUtmParamsToExternalLink } from '../../shared/helpers/url';

import * as styles from './OverlayMenu.module.scss';

interface OverlayMenuProps {
  items: MenuItem[];
  onItemClick?: () => void;
  className?: string;
  externalLinkParams?: Record<string, string>;
}

const OverlayMenu: FC<OverlayMenuProps> = memo(
  ({ items, onItemClick, className, externalLinkParams }) => {
    return (
      <ul className={classNames(styles.overlayMenu, className)}>
        {items.map(({ label, link, onClick, id, type, icon, disabled }) => {
          const url = addUtmParamsToExternalLink(link, externalLinkParams);
          const props = {
            onClick() {
              trackNavigationClick({
                label: `Mer>${label}`,
                link: url,
                id,
                type,
              });
              onClick?.();
              if (onItemClick) {
                onItemClick();
              }
            },
            className: classNames(styles.overlayMenuItemContent, {
              [styles.disabledItem]: disabled,
            }),
            children: (
              <>
                {icon}
                {label}
                {link && !isLocalUrl(link) && ' ↗'}
              </>
            ),
          };

          return (
            <li key={label}>
              {link &&
                (!isLocalUrl(link) ? (
                  // eslint-disable-next-line jsx-a11y/anchor-has-content
                  <a {...props} href={url} rel="noopener" />
                ) : (
                  <Link {...props} to={link} />
                ))}
              {!link && onClick && <button {...props} />}
            </li>
          );
        })}
      </ul>
    );
  }
);

export { OverlayMenu };
